import { render } from "./layoutHeaderProject.vue?vue&type=template&id=34b1c306&scoped=true"
import script from "./layoutHeaderProject.vue?vue&type=script&lang=js"
export * from "./layoutHeaderProject.vue?vue&type=script&lang=js"

import "./layoutHeaderProject.vue?vue&type=style&index=0&id=34b1c306&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34b1c306"]])

export default __exports__